/* unplugin-vue-components disabled */import script from "./message-abstract-file.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-abstract-file.vue?vue&type=script&setup=true&lang=ts"

import "./message-abstract-file.vue?vue&type=style&index=0&id=f976e31e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f976e31e"]])

export default __exports__